import type { GcpDiskSnapshotProperties, Snapshot } from '@repo/api-gw-sdk';

import { useViewParameters } from '@/contexts/navigation';
import { useWorkspace } from '@/contexts/useWorkspace';
import type { SidePanelStore } from '@/contexts/workspaceContext';

import { SnapshotDetails } from './snapshotDetails';
import type { RestoreActionType, VMSnapshotRowProps } from './vmSnapshotRow';

import { Panels } from '../../../panels';

export const GcpVMSnapshotRow = ({
  snap,
  vault,
  isSelected,
  onSelect,
  resource,
  snapshotSelection,
  mutateSnapshots,
}: VMSnapshotRowProps) => {
  const { rightPanel } = useWorkspace();
  const { removeParam } = useViewParameters();

  const onClose = () => {
    rightPanel.setIsOpen(false);
    removeParam('id');
  };

  const onBack = () => {
    rightPanel.setComponent({
      panel: Panels.InventoryInstance,
      props: {
        id: resource.id,
        onClose,
        initialTab: 'eon-snapshots',
      },
    });
  };

  return (
    <SnapshotDetails
      testid='vm-snapshot-row'
      resource={resource}
      key={snap.id}
      isSelected={isSelected}
      onSelect={onSelect}
      snap={snap}
      vault={vault}
      snapshotSelection={snapshotSelection}
      mutateSnapshots={mutateSnapshots}
      onRestore={(volumes, actionType) =>
        onGcpRestore(
          volumes.filter((x) => 'diskType' in x),
          actionType,
          rightPanel,
          snap,
          onClose,
          onBack
        )
      }
    />
  );
};

const onGcpRestore = (
  vols: GcpDiskSnapshotProperties[],
  actionType: RestoreActionType,
  panel: SidePanelStore,
  snap: Snapshot,
  onClose: () => void,
  onBack: () => void
) => {
  if (vols.length === 0) {
    return;
  }

  switch (actionType) {
    case 'full-instance':
      panel.setComponent({
        panel: Panels.RestoreGcpVMWizard,
        props: {
          snapshot: snap,
          onClose,
          onBack,
        },
      });
      break;
    case 'volume':
      panel.setComponent({
        panel: Panels.RestoreGcpDiskWizard,
        props: {
          snapshot: snap,
          disk: vols[0],
          onClose,
          onBack,
        },
      });
  }
};
